import { RouteConfig } from 'vue-router';

// API rules for request validation
export const apiRules = [
  { match: '/v1/profile/auth', method: 'post', auth: false, role: ['All'] },
  {
    match: '/v1/record/filter',
    auth: true,
    access: [{ role: ['All'] }, { role: ['All'] }]
  }
];

export type RouteNames = 'login' | 'final' | 'pictures' | 'map' | 'certificates' | 'label_trace';

// Navigation routes with their corresponding domains
export const navigateRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    domain: 'Dashboard',
    meta: { domain: 'Dashboard' }
  },
  {
    path: '/integrations',
    name: 'integrations',
    domain: 'AbrapaProductAPI',
    meta: { domain: 'AbrapaProductAPI' }
  },
  {
    path: '/records',
    name: 'records',
    domain: 'Record',
    meta: { domain: 'Record' }
  },
  {
    path: '/recordsAdd',
    name: 'recordsAdd',
    domain: 'Record',
    meta: { domain: 'Record' }
  },
  {
    path: '/documents',
    name: 'documents',
    domain: 'Document',
    meta: { domain: 'Document' }
  },
  {
    path: '/inspections',
    name: 'inspections',
    domain: 'Survey',
    meta: { domain: 'Survey' }
  },
  {
    path: '/inspections/answer',
    name: 'inspectionsAnswer',
    domain: 'Survey',
    meta: { domain: 'Survey' }
  },
  {
    path: '/inspections/details',
    name: 'inspectionsDetails',
    domain: 'Survey',
    meta: { domain: 'Survey' }
  },
  {
    path: '/companies',
    name: 'companies',
    domain: 'Company',
    meta: { domain: 'Company' }
  },
  {
    path: '/nomenclators/inputs',
    name: 'inputs',
    domain: 'Input',
    meta: { domain: 'Input' }
  },
  {
    path: '/nomenclators/products',
    name: 'products',
    domain: 'Culture',
    meta: { domain: 'Culture' }
  },
  {
    path: '/nomenclators/survey',
    name: 'survey',
    domain: 'surveyAdm',
    meta: { domain: 'surveyAdm' }
  },
  {
    path: '/nomenclators/survey/surveyAdd',
    name: 'surveyAdd',
    domain: 'surveyAdm',
    meta: { domain: 'surveyAdm' }
  },
  {
    path: '/nomenclators/survey/questionAdd',
    name: 'questionAdd',
    domain: 'surveyAdm',
    meta: { domain: 'surveyAdm' }
  },
  {
    path: '/nomenclators/equipments',
    name: 'equipments',
    domain: 'Equipment',
    meta: { domain: 'Equipment' }
  },
  {
    path: '/nomenclators/operators',
    name: 'operators',
    domain: 'Operator',
    meta: { domain: 'Operator' }
  },
  {
    path: '/nomenclators/producers',
    name: 'producers',
    domain: 'Producer',
    meta: { domain: 'Producer' }
  },
  {
    path: '/nomenclators/seasons',
    name: 'seasons',
    domain: 'Season',
    meta: { domain: 'Season' }
  },
  {
    path: '/nomenclators/storage-types',
    name: 'storage-types',
    domain: 'StorageDeviceType',
    meta: { domain: 'StorageDeviceType' }
  },
  {
    path: '/nomenclators/locations',
    name: 'locations',
    domain: 'Location',
    meta: { domain: 'Location' }
  },
  {
    path: '/nomenclators/storage',
    name: 'storage',
    domain: 'StorageDevice',
    meta: { domain: 'StorageDevice' }
  },
  {
    path: '/nomenclators/roles',
    name: 'roles',
    domain: 'Role',
    meta: { domain: 'Role' }
  },
  {
    path: '/nomenclators/proccess',
    name: 'proccess',
    domain: 'Process',
    meta: { domain: 'Process' }
  },
  {
    path: '/nomenclators/details',
    name: 'details',
    domain: 'Structure',
    meta: { domain: 'Structure' }
  },
  {
    path: '/reports/traceability-report',
    name: 'traceability-report',
    domain: 'Traceability',
    meta: { domain: 'Traceability' }
  },
  {
    path: '/reports/custom',
    name: 'custom-reports',
    domain: 'CustomReport',
    meta: { domain: 'CustomReport' }
  },
  {
    path: '/reports/stock-report',
    name: 'stock-report',
    domain: 'StockReport',
    meta: { domain: 'StockReport' }
  },
  {
    path: '/reports/general-report',
    name: 'general-report',
    domain: 'GeneralReport',
    meta: { domain: 'GeneralReport' }
  },
  {
    path: '/reports/biorganic-report',
    name: 'biorganic-report',
    domain: 'BiorganicReport',
    meta: { domain: 'BiorganicReport' }
  }
] as const;

// Rutas públicas que no requieren autenticación
export const publicRoutes: RouteNames[] = [
  'login',
  'final',
  'pictures',
  'map',
  'certificates',
  'label_trace'
];

// Rutas prioritarias para redirección
export const priorityRoutes = [
  { name: 'dashboard', domain: 'Dashboard' },
  { name: 'records', domain: 'Record' },
  { name: 'documents', domain: 'Document' },
  { name: 'companies', domain: 'Company' },
  { name: 'locations', domain: 'Location' },
  { name: 'storage', domain: 'StorageDevice' }
];

// Routes that are always accessible
export const globalRoutes = [
  'integrations',
  'translations',
  'units',
  'group-units',
  'document-description',
  'document-types',
  'document-authority',
  'notifications',
  'configReportLabel',
  'printReportLabel',
  'agtAdminSDT'
] as const;

// Helper function to map routes with All domain
export const mapRoutesWithAllDomain = (routes: typeof navigateRoutes) => {
  return routes.map(route => ({
    ...route,
    meta: { domain: 'All', next: false }
  }));
};

// Export mapped routes for backwards compatibility
export const mappedRoutes = mapRoutesWithAllDomain(navigateRoutes);
